
import { FaqTypes as Type } from '../../../types/faq';
const initialState = {
  list: null,
  loading: false,
  error: null,
};

const FAQListReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case Type.GET_FAQ_LIST_REQUEST:
      return { ...state, loading: true, error: null, list: null };

    case Type.GET_FAQ_LIST_REQUEST_SUCCESS:
      return {
        ...state,
        list: action.payload,
        loading: false,
        error: null
      };
    case Type.GET_FAQ_LIST_REQUEST_FAILURE:
      return { ...state, error: action.error, loading: false, list: null };
    default:
      return state;
  }
};

export default FAQListReducer;